<template>
  <div
    v-if="objPicked"
    class="row"
  >
    <div
      v-if="property.id"
      class="row obj-selection"
    >
      <div class="col-sm-4">
        <p>Ausgewähltes Objekt</p>
      </div>
      <div class="col-sm-6">
        <p>
          {{ property.street }} {{ property.hsnr }}, {{ property.zip }} {{ property.city }}, {{ property.county }}
        </p>
      </div>
      <div class="col-sm-2">
        <button
          class="btn clr-btn btn-danger"
          @click="clearData"
        >
          CLR
        </button>
      </div>
    </div>
    <DocCards :documents="documents"></DocCards>
  </div>
</template>
<script>
import DocCards from '../components/DocCards.vue'

export default {
  components: {
    DocCards
  },
  props: {
    property: {
			type: Object,
			required: true
		}
  },
  data () {
    return {
      objPicked: false,
      documents: [],
      file: ''
    }
  },
  watch: {
    property: function (newVal) {
      if (newVal.id !== undefined) {
        this.getPropertyDocs()
      } else {
        this.objPicked = false
      }
    }
  },
  methods: {
    getPropertyDocs () {
      this.objPicked = false
      this.$axios.get(process.env.VUE_APP_BASE_URI + 'sadmin/docs/' + this.property.id)
        .then((response) => {
          this.documents = response.data
          this.objPicked = true
        })
    },
    clearData () {
      localStorage.removeItem('order_id')
      this.$router.go()
    }
  }
}
</script>
